import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      component: Home,
      alias: '/home'
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard/ViewDashboard.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard/ViewDashboard.vue')
    },
    {
      path: '/artigos',
      name: 'artigos',
      component: () => import(/* webpackChunkName: "blog" */ './views/Blog/Artigos.vue')
    },
    {
      path: '/links',
      name: 'links',
      component: () => import(/* webpackChunkName: "blog" */ './views/Blog/Links.vue')
    },
    {
      path: '/imagens',
      name: 'imagens',
      component: () => import(/* webpackChunkName: "blog" */ './views/Blog/Imagens.vue')
    },
    {
      path: '/tags',
      name: 'tags',
      component: () => import(/* webpackChunkName: "blog" */ './views/Blog/Tags.vue')
    },
    {
      path: '/ajuda',
      name: 'ajuda',
      component: () => import(/* webpackChunkName: "configuracoes" */ './views/Configuracoes/Ajuda.vue')
    },
    {
      path: '/licenca',
      name: 'licenca',
      component: () => import(/* webpackChunkName: "configuracoes" */ './views/Configuracoes/Licenca.vue')
    },
    {
      path: '/parametros',
      name: 'parametros',
      component: () => import(/* webpackChunkName: "configuracoes" */ './views/Configuracoes/Parametros.vue')
    },
    {
      path: '/sobre',
      name: 'sobre',
      component: () => import(/* webpackChunkName: "configuracoes" */ './views/Configuracoes/Sobre.vue')
    },
    {
      path: '/cliques',
      name: 'cliques',
      component: () => import(/* webpackChunkName: "cliques" */ './views/Estatisticas/Cliques.vue')
    },
    {
      path: '/compartilhamentos',
      name: 'compartilhamentos',
      component: () => import(/* webpackChunkName: "cliques" */ './views/Estatisticas/Compartilhamentos.vue')
    },
    {
      path: '/likes',
      name: 'likes',
      component: () => import(/* webpackChunkName: "cliques" */ './views/Estatisticas/Likes.vue')
    },
    {
      path: '/suporte',
      name: 'suporte',
      component: () => import(/* webpackChunkName: "suporte" */ './views/Suporte.vue')
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ './views/Logout.vue')
    },
    {
      path: '/vuetify',
      name: 'vuetify',
      component: () => import(/* webpackChunkName: "logout" */ './views/Vuetify/VuetifyExemplo.vue')
    },
    {
      path: '/buefy',
      name: 'buefy',
      component: () => import(/* webpackChunkName: "logout" */ './views/Buefy/BuefyExemplo.vue')
    }
  ]
})
